export enum InputMode {
  TEXT = 'TEXT',
  PASSWORD = 'PASSWORD',
  PHONE = 'PHONE',
  MASKED = 'MASKED',
  CURRENCY = 'CURRENCY'
}

export namespace InputMode {
  export const isPassword = (input: InputMode) => input === InputMode.PASSWORD;
  export const isPhone = (input: InputMode) => input === InputMode.PHONE;
  export const isText = (input: InputMode) => input === InputMode.TEXT;
  export const isMasked = (input: InputMode) => input === InputMode.MASKED;
  export const isCurrency = (input: InputMode) => input === InputMode.CURRENCY;
}